module.exports = __webpack_public_path__ + "static/media/icon-comments.54f089e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-comments.svg
// module id = 535
// module chunks = 0